// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fce61171","455":"9e9b6dce","977":"b06728f5"}[chunkId] + ".chunk.js";
};